import * as React from 'react'
import type { ImageProps } from 'types/content-editor'
import { updateImageProp } from '@disco/content-editor/prop-utils'
import { fixLink } from '@disco/utils/links'
import ImagePropsView from 'components/common/rich-text-editor/toolbar/element-settings/image/view'

class ImageBlockSettings extends React.Component<
  {
    content: ImageProps
    onChange: (value: ImageProps) => void
    onImageSet: (arg0: Record<string, any>) => any
    onImageUpload: () => any
    maxImageWidth: number
    validationErrors: Record<string, any>
  },
  null
> {
  _onChange: (e: React.ChangeEvent<HTMLInputElement>) => void = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = updateImageProp(
      this.props.content,
      e.target.name,
      e.target.name === 'src' || e.target.name === 'link'
        ? fixLink(e.target.value)
        : e.target.value,
      this.props.maxImageWidth,
    )
    this.props.onChange(value)
  }
  _onImageSet: (value: ImageProps) => any = (value: ImageProps) =>
    this.props.onChange(value)

  render(): React.ReactElement<'div'> {
    const { content, maxImageWidth, validationErrors, onImageUpload } =
      this.props
    return (
      <div className="content-editor__image-block">
        <ImagePropsView
          className="rich-text-toolbar__settings__list"
          value={content}
          maxImageWidth={maxImageWidth}
          onChange={this._onChange}
          onImageSet={this._onImageSet}
          onImageUpload={onImageUpload}
          validationErrors={validationErrors}
        />
      </div>
    )
  }
}

export default ImageBlockSettings
